import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=13b6c244&scoped=true&"
import script from "./Calc.vue?vue&type=script&lang=js&"
export * from "./Calc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6c244",
  null
  
)

export default component.exports